// La coquille du studio : la barre latérale, l'en-tête, le compte (V4Layout).
export default {
  nav: {
    portfolio: 'Portefeuille',
    radar: 'Radar',
    catalogue: 'Catalogue',
    zeus: 'Zeus',
    taches: 'Mes tâches',
    sonar: 'Explorer',
    conversations: 'Conversations',
    channel: 'Dashboard',
    audits: 'Audit',
    drifts: 'Drifts',
    'wizard-dossier': 'Créer sa marque',
    monday: 'Brief du lundi',
    decisions: "Bureau d'études",
    'dossier-precog': 'PreCog',
    arena: 'ISOs',
    calendar: 'Calendrier',
    map: 'Carte cosmique',
    config: 'Config & collecte',
    sentinel: 'Sentinel',
    discovery: 'Discovery',
    replica: 'Replica',
    'ent-formats': 'Formats',
    'ent-soirees': 'Soirées & registre',
    'ent-diffuseurs': 'Diffuseurs',
    'ent-pays': 'Pays de l’export',
    'ent-brief': 'Le brief',
    'polis-projection': 'Projections',
    'polis-electorat': 'Électorat',
    'polis-scenarios': 'Scénarios',
    'polis-candidats': 'Candidats',
    'polis-sonar': 'Sonar',
    'polis-registre': 'Registre',
    'polis-scrutin': 'Réglages de l’élection',
    'polis-personnalites': 'Personnalités',
    'polis-suivis': 'Suivis',
    wizard: 'Nouvelle marque',
    precog: 'PreCog',
    calibration: 'Calibration',
    equipe: 'Équipe',
  },
  groupe: {
    observer: 'Observer',
    interroger: 'Interroger',
    dossier: 'Dossier',
    beta: 'Orion Beta',
    projector: 'Projector',
    polis: 'Polis',
    organisation: 'Organisation',
    configuration: 'Configuration',
    administration: 'Administration',
  },
  dossier: {
    courant: 'Le dossier courant - tout ce que vous voyez s’y rapporte',
    choisir: '- choisir un dossier -',
    archive: '(archivé)',
    aucun: 'aucun dossier',
    le: 'Le dossier',
    mes: 'Mes dossiers',
  },
  projector: {
    dossier: 'Le dossier de Projector',
    choisir: '- choisir un dossier -',
    creer: '+ Créer un format',
    format: 'Fiche',
    sonar: 'Sonar',
    documents: 'Documents',
    ecoute: 'Écoute',
    suivi: 'Suivi',
  },
  polis: {
    election: 'L’élection de Polis',
    choisir: '- choisir une élection -',
    nouvelle: '+ Nouvelle élection',
    enPreparation: '(en préparation)',
  },
  aucunModule: {
    titre: 'Aucun module accordé',
    texte: 'L’administrateur de votre organisation vous les attribue depuis la page Équipe.',
  },
  donneesAJour: 'Données à jour',
  organisation: 'Organisation',
  seDeconnecter: 'Se déconnecter',
  sortir: 'Sortir',
  theme: 'Basculer sombre / clair',
  langue: 'Langue',
  nouvelleVersion: 'Une nouvelle version d’Orion est en ligne.',
  recharger: 'Recharger',
}
